<template>
    <div>
        <el-tree
            :props="props"
            :load="loadNode"
            lazy>
        </el-tree>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                props: {
                    label: 'name',
                    children: 'zones',
                    isLeaf: 'leaf'
                },
            }
        },
        created() {

        },
        methods: {
            loadNode(node, resolve){
                if (node.level === 0) {
                    return resolve([{ name: 'region' }]);
                }
                if (node.level > 1) return resolve([]);

                setTimeout(() => {
                    const data = [{
                        name: 'leaf',
                        leaf: true
                    }, {
                        name: 'zone'
                    }];

                    resolve(data);
                }, 500);
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>